import { CorporationDto } from '../corporation/corporation.dto';

export interface CorporatePositionDto {
  id: string; // Guid
  corporationId: string; // Guid
  title: string;
  description?: string | null;
  department?: string | null;
  level: number; // 1-10
  isActive: boolean;
  isDefault: boolean;
  createdAt: string; // DateTime as ISO string
  updatedAt?: string | null; // DateTime as ISO string
  corporation?: CorporationDto | null;
}
